/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown> }} Portals_Check_GroupInputs */

const cs_portals_check_group = /** @type {(inputs: Portals_Check_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.group}`)
};

const en_portals_check_group = /** @type {(inputs: Portals_Check_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.group}`)
};

/**
* | output |
* | --- |
* | "{group}" |
*
* @param {Portals_Check_GroupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_group = /** @type {((inputs: Portals_Check_GroupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_GroupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_group(inputs)
	return cs_portals_check_group(inputs)
});